/**
 * Admin-editable reminder cadence (Phase 2): which time-based reminders fire and
 * how far ahead. Read by supervisor+admin; written by admins.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ReminderSettings, ReminderSettingsUpdateInput } from '@vari-crew/schemas';
import { apiCall } from '@/lib/api';

const KEY = ['reminder-settings'] as const;

export function useReminderSettings(enabled = true) {
  return useQuery<ReminderSettings>({
    queryKey: KEY,
    enabled,
    queryFn: () => apiCall<ReminderSettings>('/reminders/settings'),
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateReminderSettings() {
  const qc = useQueryClient();
  return useMutation<ReminderSettings, Error, ReminderSettingsUpdateInput>({
    mutationFn: (body) => apiCall<ReminderSettings>('/reminders/settings', { method: 'PUT', body }),
    onSuccess: (s) => qc.setQueryData(KEY, s),
  });
}
